//@ts-check

import { get, getAll } from "../utilities/querySelector";

/** @type {Animation|false} */
let animation = false;

let activeElement;

export const modalContainer = get( '.site-modal' );
export const closeButton = get( '[data-modal-close]', modalContainer );

closeButton.addEventListener( 'click', fadeout );
modalContainer.addEventListener( 'click', ( e ) => {
  if ( e.target === modalContainer ) {
    fadeout();
  }
} );


const openers = getAll( '[data-modal-open]' );
openers.forEach( opener => opener.addEventListener( 'click', async ( e ) => {
  e.preventDefault();

  if ( is_active() ) {
    await fadeout();
  } else {
    activeElement = opener;
  }

  const modal = opener.dataset?.modalOpen ?? '';
  activate( modal );
} )
);


/**
 * "Activates" the specified modal, opening the modal in the process
 * @param {string} modalName
 */
export function activate( modalName ) {
  const modal = get( `[data-modal=${modalName}]`, modalContainer );
  if ( !modal ) return console.warn( `No modal with name ${modal} to open` );

  modal.setAttribute( 'data-active', '' );
  modalContainer.setAttribute( 'data-active', '' );
  fadein();
  closeButton.focus();
}

/**
 * Sets the active state of all modals to false
 */
function deactivate() {
  modalContainer.removeAttribute( 'data-active' );
  getAll( `[data-active]`, modalContainer ).forEach( activeModal => activeModal.removeAttribute( 'data-active' ) );

  // Remove status of contact form
  get( '.wpcf7-form', modalContainer )?.reset();
}

/**
 * Opens the main modal up
 */
async function fadein() {
  document.documentElement.style.overflow = 'hidden';

  animation = modalContainer.animate( {
    opacity: [0, 1],
    transform: ['translateY(2rem) scale(0.95)', 'translateY(0rem) scale(1)']
  }, { duration: 350, easing: 'ease' } );
}

function fadeout() {
  activeElement?.focus();

  animation = modalContainer.animate( {
    opacity: [1, 0],
    transform: ['translateY(0) scale(1)', 'translateY(-2rem) scale(0.95)']
  }, { duration: 350, easing: 'ease' } );

  return new Promise( ( res ) => animation.addEventListener( 'finish', () => {
    deactivate();
    document.documentElement.style.overflow = '';
    res( true );
  }, { once: true } ) );

}


function is_active() {
  return modalContainer.dataset?.active !== undefined;
}